import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  uploadFileRequest: ["leave_id", "children_id", "files"],
  uploadFileSuccess: ["Status"],
  uploadFileFailure: null,
  clearUploadFileData: null,
});

export const UploadFileTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  leave_id: null,
  children_id: null,
  fetching: null,
  error: null,
  success: null,
  Status: null,
  files: null,
});

export const UploadFileSelectors = {
  getData: (state: any) => state.uploadFile.data,
  isFetching: (state: any) => state.uploadFile.fetching,
  isSuccess: (state: any) => state.uploadFile.success,
  hasError: (state: any) => state.uploadFile.error,
};

export const request = (state: any, { leave_id, children_id, files }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id: leave_id,
    children_id: children_id,
    files: files,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { Status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    Status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const clear = (state: any) => {
  return state.merge ? state.merge(INITIAL_STATE) : INITIAL_STATE;
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPLOAD_FILE_REQUEST]: request,
  [Types.UPLOAD_FILE_SUCCESS]: success,
  [Types.UPLOAD_FILE_FAILURE]: failure,
  [Types.CLEAR_UPLOAD_FILE_DATA]: clear,
});
